import styled from 'styled-components';

const NavTabPayment = styled.ul`
	border-radius: 10px !important;
	background-color: ${({ theme }) => theme.backgroundNavActivePayment};
	display: flex;
	flex-direction: row;
	justify-content: center;
	align-items: center;

	.active > a {
		border-radius: 10px !important;
		background-color: ${({ theme }) =>
			theme.backgroundNavActivePayment} !important;
		color: ${({ theme }) => theme.colorNavActivePayment} !important;
		font-weight: ${({ theme }) => theme.fontWeightNavPayment} !important;

		svg {
			color: ${({ theme }) => theme.colorNavSvgActivePayment};
		}
	}

	li {
		width: 100%;
	}

	li > a {
		border-radius: 10px !important;
		font-size: 16px;
		padding: 11px 20px;
		background: ${({ theme }) => theme.backgroundNavPayment};
		border: 0;
		border: 0px solid ${({ theme }) => theme.backgroundNavPayment};
		color: ${({ theme }) => theme.colorNavPayment};
		margin: 0px;
		text-decoration: none;
	}

	li > a:hover {
		border: 0px solid ${({ theme }) => theme.backgroundNavPayment} !important;
	}

	a {
		font-weight: ${({ theme }) => theme.fontWeightNavPayment} !important;
		display: flex !important;
		flex-direction: row;
		align-items: center;
		justify-content: center;
		background-color: ${({ theme }) =>
			theme.backgroundNavAnchorPayment} !important;
		font-family: ${({ theme }) => theme.fontFamilyNavPayment};
	}

	svg {
		margin-right: 10px;
		color: ${({ theme }) => theme.colorNavSvgPayment};
	}
`;

export default NavTabPayment;
